import { View } from "ui/atoms/view";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { useAssessmentEdit } from "../context/AssessmentEditContext";
import clsx from "clsx";
import { useFormState } from "react-hook-form";
import { TrashIcon } from "ui/gluestack/icon";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

interface Props {
  className?: string;
}
export function AssessmentEditSaveChangesOrganism({ className }: Props) {
  const {
    isSaving,
    isEditing,
    hasEditingPermission,
    saveAssessment,
    handleSubmit,
    deleteAssessment,
    cancel,
    control,
  } = useAssessmentEdit();
  const { isDirty } = useFormState({ control });

  return (
    <View className={clsx("flex-row justify-between py-2 gap-4", className)}>
      <View>
        <PermissionCheck permission={PermissionsEnums.DELETE_FORM}>
          {isEditing ? (
            <Button
              variant="outline"
              action="negative"
              onPress={deleteAssessment}
            >
              <ButtonIcon as={TrashIcon} />
              <ButtonText>Delete assessment</ButtonText>
            </Button>
          ) : null}
        </PermissionCheck>
      </View>
      <View className="flex flex-row gap-4">
        {hasEditingPermission ? (
          <>
            <Button
              variant="outline"
              action="primary"
              isDisabled={!isDirty || isSaving}
              onPress={cancel}
            >
              <ButtonText>Cancel</ButtonText>
            </Button>
            <Button
              variant="solid"
              action="primary"
              isDisabled={!isDirty || isSaving}
              onPress={handleSubmit(saveAssessment)}
            >
              <ButtonText>
                {isSaving ? "Saving..." : "Save Assessment"}
              </ButtonText>
            </Button>
          </>
        ) : null}
      </View>
    </View>
  );
}
